<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false"
           @on-ok="ok" :loading="loading" @on-cancel="cancel"
           :width="650"
    >
      <h3 slot="header" class="modal-header">修改备件</h3>
      <div v-if="data.businessLicenseList && data.businessLicenseList">
        <h4>资质照片</h4>
        <div style="padding: 10px 30px">
          <div class="inline-block" v-for="(item,index) in data.businessLicenseList" :key="'keyA'+index">
            <img :src="item.attachmentImgUrl" alt="">
            <Upload style="display: inline-block"
              :action="baseUrl+'/file/uploadFile'"
              :data="{type:index}"
              :on-success="handleSuccess1"
              :headers="{'Access-Token':token}"
              :show-upload-list="false"
              :on-error="handleError"
              :format="['jpg','jpeg','png']"
              :on-format-error="formatError"
            >
              <a>修改</a>
            </Upload>
          </div>
        </div>
      </div>
      <div v-if="data.grantAuthList">
        <h4>委托授权书</h4>
        <div style="padding: 10px 30px">
          <div class="inline-block" v-for="(item,index) in data.grantAuthList" :key="'keyB'+index">
            <img :src="item.attachmentImgUrl" alt="">
            <Upload style="display: inline-block"
              :action="baseUrl+'/file/uploadFile'"
              :data="{type:index}"
              :on-success="handleSuccess2"
              :headers="{'Access-Token':token}"
              :show-upload-list="false"
              :on-error="handleError"
              :format="['jpg','jpeg','png']"
              :on-format-error="formatError"
            >
              <a>修改</a>
            </Upload>
          </div>
        </div>
      </div>

      <div>
        <div class="inline-block" v-for="(item,index) in data.signMeterDeliveryImg" :key="'keyC'+index">
        <div v-if="item.meterTypeName" style="display: inline-block">
          <h4>{{item.meterTypeName}}表</h4>
          <div style="padding: 10px 30px">
            <img :src="item.meterPic" alt="">
            <Upload style="display: inline-block"
              :action="baseUrl+'/file/uploadFile'"
              :data="{type:index}"
              :on-success="handleSuccess3"
              :headers="{'Access-Token':token}"
              :show-upload-list="false"
              :on-error="handleError"
              :format="['jpg','jpeg','png']"
              :on-format-error="formatError"
            >
              <a>修改</a>
            </Upload>
          </div>
        </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {getSparePart,updateSparePart} from "../../../../api/contractList";
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";

  export default {
    name: "UpdateSpartPart",
    components: {},
    props: {
      n: {
        type: Number,
        default: 0
      },
      contractFid: {
        type: String,
        default: ''
      },
    },
    watch: {
      n() {
        this.data={}
        this.getSparePart()
        this.isShow = true
      }
    },
    data() {
      return {
        data: {},
        loading: true,
        isShow: false,
        token: '',
        baseUrl: '',
      }
    },
    methods: {
      handleSuccess3(res){
        let index = Number(res.data.type)
        this.data.signMeterDeliveryImg[index].meterPic = res.data.url
      },
      handleSuccess2(res) {
        let index = Number(res.data.type)
        this.data.grantAuthList[index].attachmentImgUrl = res.data.url
        this.data.grantAuthList[index].fid = res.data.fid
      },
      handleError() {
      },
      formatError() {
        this.$Message.info('请选择图片文件（jpg、jpeg、png）')
      },
      handleSuccess1(res, file) {
        let index = Number(res.data.type)
        this.data.businessLicenseList[index].attachmentImgUrl = res.data.url
        this.data.businessLicenseList[index].fid = res.data.fid
      },
      getSparePart() {
        let params = {
          contractFid: this.contractFid
        }
        getSparePart(params).then(res => {
          res.data &&( this.data = res.data)
        }).catch(error => {})
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){
        updateSparePart(this.data).then(res=>{
          this.$Message.success('修改备件成功')
          this.isShow=false
        }).catch(error=>{
          this.$Message.info('修改备件失败')
          this.isShow=false
        })
      },
      cancel(){
      }
    },
    created() {
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }
  }
</script>

<style scoped>
  .inline-block {
    display: inline-block;
    margin-right: 30px;
  }

  img {
    width: 160px;
    height: 100px;
  }

</style>
